/** Section 1 */
import Section1Frame2xPng from './assets/section1/Frame@2x.png'
import Section1FrameWebp from './assets/section1/Frame.webp'
import Section1Frame2xWebp from './assets/section1/Frame@2x.webp'
import Section1FrameSecond2xPng from './assets/section1/Frame2@2x.png'
import Section1FrameSecondWebp from './assets/section1/Frame2.webp'
import Section1FrameSecond2xWebp from './assets/section1/Frame2@2x.webp'

/* Section 2 */
import Section2Frame2xPng from './assets/section2/Frame@2x.png'
import Section2FrameWebp from './assets/section2/Frame.webp'
import Section2Frame2xWebp from './assets/section2/Frame@2x.webp'

/* Section 3 */
import Section3Frame2xPng from './assets/section3/Frame@2x.png'
import Section3FrameWebp from './assets/section3/Frame.webp'
import Section3Frame2xWebp from './assets/section3/Frame@2x.webp'

/* Section 4 */
import Section4Frame2xPng from './assets/section4/Frame@2x.png'
import Section4FrameWebp from './assets/section4/Frame.webp'
import Section4Frame2xWebp from './assets/section4/Frame@2x.webp'

/* Section 5 */
import Section5Frame2xPng from './assets/section5/Frame@2x.png'
import Section5FrameWebp from './assets/section5/Frame.webp'
import Section5Frame2xWebp from './assets/section5/Frame@2x.webp'

/* Section 6 */
import Section6Frame2xPng from './assets/section6/Frame@2x.png'
import Section6FrameWebp from './assets/section6/Frame.webp'
import Section6Frame2xWebp from './assets/section6/Frame@2x.webp'

/* Section 7 */
import Section7Frame2xPng from './assets/section7/Frame@2x.png'
import Section7FrameWebp from './assets/section7/Frame.webp'
import Section7Frame2xWebp from './assets/section7/Frame@2x.webp'

import Section7FrameMobilePng from './assets/section7/FrameMobile.png'
import Section7FrameMobile2xPng from './assets/section7/FrameMobile@2x.png'
import Section7FrameMobileWebp from './assets/section7/FrameMobile.webp'
import Section7FrameMobile2xWebp from './assets/section7/FrameMobile@2x.webp'

export interface Image {
  src2x: string
  webp: string
  webp2x: string
  mobile?: {
    src: string
    src2x: string
    webp: string
    webp2x: string
  }
  width: number
  height: number
  alt?: string
}
export interface Item {
  key: number
  heading: string
  description: string
  images: Image[]
}

export const items: Item[] = [
  {
    key: 0,
    heading: `The “growth-at-all-costs” era is&nbsp;over `,
    description: `Buckle up. With volatility in the global economy, companies have realized that a growth-at-all-costs mindset is neither efficient nor scalable, and have refocused their workforce, budgets, and business strategy around efficiency.`,
    images: [
      {
        src2x: Section1Frame2xPng,
        webp: Section1FrameWebp,
        webp2x: Section1Frame2xWebp,
        height: 280,
        width: 640,
        alt: `61% of respondents reporting that the “growth-at-all-costs” mentality is over.`,
      },
      {
        src2x: Section1FrameSecond2xPng,
        webp: Section1FrameSecondWebp,
        webp2x: Section1FrameSecond2xWebp,
        height: 280,
        width: 640,
        alt: `93% of businesses are taking steps to plan for a recession.`,
      },
    ],
  },
  {
    key: 1,
    heading: `Efficiency and profitability are the new north stars`,
    description: `Say goodbye to the bells and whistles of the growth era. Companies are now leaning into their bottom line by focusing on what works today to support any volatility tomorrow.`,
    images: [
      {
        src2x: Section2Frame2xPng,
        webp: Section2FrameWebp,
        webp2x: Section2Frame2xWebp,
        height: 300,
        width: 640,
        alt: `62% of respondents say their business has increased their focus on profitability over the past 12 months.`,
      },
    ],
  },
  {
    key: 2,
    heading: `Marketing budgets are declining`,
    description: `As business budgets decline, marketing departments will need to be thoughtful and creative about what technology they use and how they maximize existing budgets for new campaigns.`,
    images: [
      {
        src2x: Section3Frame2xPng,
        webp: Section3FrameWebp,
        webp2x: Section3Frame2xWebp,
        height: 300,
        width: 640,
        alt: `Over half (57%) of respondents say their company is currently spending money on ineffective tools that they don’t need.`,
      },
    ],
  },
  {
    key: 3,
    heading: `A wave of consolidation is coming`,
    description: `Is this product really delivering ROI? Can we maximize success with technology that delivers on multiple business goals? As businesses begin to streamline their technology adoption, these are the hard questions companies are asking themselves.`,
    images: [
      {
        src2x: Section4Frame2xPng,
        webp: Section4FrameWebp,
        webp2x: Section4Frame2xWebp,
        height: 300,
        width: 640,
        alt: `83% of respondents plan to simplify their marketing tech stack within the next 12 months.`,
      },
    ],
  },
  {
    key: 4,
    heading: `Businesses are doubling down on what works`,
    description: `While some experimentation is still happening, most businesses are leaning into tried and true channels like email to grow revenue.`,
    images: [
      {
        src2x: Section5Frame2xPng,
        webp: Section5FrameWebp,
        webp2x: Section5Frame2xWebp,
        height: 300,
        width: 640,
        alt: `69% of businesses say they are leaning into channels with proven ROI.`,
      },
    ],
  },
  {
    key: 5,
    heading: `Data is the next frontier of business growth`,
    description: `So how can businesses continue to grow amid a turbulent market? By leaning into technology that helps them understand buyer behavior, improve marketing performance, and deliver hyper-personalized experiences.`,
    images: [
      {
        src2x: Section6Frame2xPng,
        webp: Section6FrameWebp,
        webp2x: Section6Frame2xWebp,
        height: 300,
        width: 640,
        alt: `71% of businesses are prioritizing capturing and leveraging first-party data better.`,
      },
    ],
  },
  {
    key: 6,
    heading: `Customer data platforms will be how businesses get there`,
    description: `As customer engagement continues to be paramount to business success, investing in technology that both collects and analyzes customer data will be essential in helping businesses continue to grow.`,
    images: [
      {
        src2x: Section7Frame2xPng,
        webp: Section7FrameWebp,
        webp2x: Section7Frame2xWebp,
        mobile: {
          src: Section7FrameMobilePng,
          src2x: Section7FrameMobile2xPng,
          webp: Section7FrameMobileWebp,
          webp2x: Section7FrameMobile2xWebp,
        },
        height: 240,
        width: 640,
        alt: `Businesses who are using CDPs report almost 2x higher customer satisfaction levels than those without a CDP.`,
      },
    ],
  },
]
